<template>
    <div class="paragraph_container">        
        <div class="content">
            <div class="title">{{ title || 'Атрибут title не указан' }}</div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "Paragraph",
    props: ["title"],
};
</script>

<style scoped>
.paragraph_container {
    overflow: hidden;
    padding: 5px;
    margin-top: 5px;
}

.paragraph_container>.content {
    display: flex;
    flex-direction: column;
}

.paragraph_container>.content>.title {
    text-align: center;
    color: black;
    margin-bottom: 3px;
}
</style>
